import ProveedorShow from './ProveedorShow'
export {ProveedorShow}
export default ProveedorShow
